<template>
  <div class="panel-item">
    <div class="title_name" style="display: flex; justify-content: space-between;">
      <div>店铺资金流向情况</div>

      <div class="btns-box">
        <div :class="type==1?'btn-item-s':'btn-item'" @click="type=1;select_change()" >销售</div>
        <div :class="type==2?'btn-item-s':'btn-item'" @click="type=2;select_change()">退款</div>
      </div>
    </div>

    <div ref="chart" class="chart-container"></div>


  </div>
</template>

<script>

import * as echarts from "echarts";

export default {
  components: {},
  props: {
    name: {
      type: String,
      default: ''
    },
    chartblock: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      type: 1,//1 销售、2 退款


      labels: [],
      chartInstance: null,

      series: []
    }
  },
  watch: {
    chartblock: {
      handler(tNew) {
          this.select_change()
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  },
  methods: {
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chart)
      this.updateChart()
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },
    select_change() {
      let newVal
      //1 销售、2 退款
      if (this.type == 1) {
        newVal = this.chartblock.sell
      } else if (this.type == 2) {
        newVal =  this.chartblock.refund
      }

      if (!newVal||newVal.length == 0) {
        this.labels = []
        this.series = []
        this.updateChart()
        return
      }

      this.labels = newVal[0].values.map(m => m.x)
      this.series = []
      this.series = newVal.map(m => {
        return {
          name: m.shop_name,
          type: 'line',  // Changed to bar chart
          data: m.values.map(mv=>mv.y),
          barWidth: '40%'
        }
      })
      this.updateChart()
    },
    updateChart() {
      if (!this.chartInstance) return

      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show:false
          // 根据实际数据动态设置图例
          // data: this.series.map(item => item.name),
          // textStyle: {
          //   color: '#fff'
          // }
        },
        grid: {
          left: '6%',
          right: '6%',
          bottom: '6%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          nameLocation: 'middle',
          nameGap: 20,
          nameTextStyle: {
            padding: [4, 0, 0, 230]
          },
          // 确保在无数据时正确显示空数组
          data: this.labels || [],
          axisLine: {lineStyle: {color: '#ccc'}},
          axisLabel: {color: '#fff'}
        },
        yAxis: {
          type: 'value',
          nameTextStyle: {
            padding: [0, 34, 0, 0]
          },
          axisLine: {lineStyle: {color: '#ccc'}},
          axisLabel: {color: '#fff'},
          splitLine: {lineStyle: {color: '#444'}}
        },
        series: this.series || []
      }

      // 使用 setOption 的 replaceMerge 模式确保完全替换
      this.chartInstance.setOption(option, true)
    }

  }


}
</script>

<style lang="scss" scoped>


.panel-item {
  width: 830px !important;
  height: 580px !important;
  background: url(../../../../assets/_s-image_sector_bg4.png) no-repeat !important;
  background-size: 100% 100% !important;
  margin-top: 40px;
  position: relative;
}

.title_name {
  padding: 26px 0 20px 100px;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
}


.btns-box {
  display: flex;
  padding-right: 20px;
  gap: 10px;
  font-size: 16px;

  .btn-item {
    width: 60px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: url(../../../../assets/head_btn2.png) no-repeat;
    background-size: 100% 100%;
  }

  .btn-item-s {
    width: 60px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: url(../../../../assets/head_btn.png) no-repeat;
    background-size: 100% 100%;
  }
}


.chart-container {
  width: 100%;
  height: 500px;
}

</style>